import React, { useState, useEffect } from "react";
import "./AboutProject.css";

import Button from "@mui/material/Button";
import ContactForm from "../ContactForm/ContactForm"; 

import ab1 from "../../assets/imgs/ab1.jpg";
import ab2 from "../../assets/imgs/ab2.jpg";
import ab3 from "../../assets/imgs/ab3.jpg";
import ab4 from "../../assets/imgs/ab4.jpg";

export default function AboutProject() {
  const [expanded, setExpanded] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const topText =
    "Arvind Smart Spaces, Plots Vadodara — A premier investment address. Pre-register today for priority preference, launch benefits & special discounts re-register today for priority preference, launch benefits & special discounts!";

  useEffect(() => {
    document.body.style.overflow = showForm ? "hidden" : "auto";
  }, [showForm]);

  return (
    <div className="abmn" id="about">
      <div className="maxW">
        <div className="abTp">
          <div>
            <h2>About Project</h2>

            <p className={expanded ? "showFull" : "twoLine"}>{topText}</p>

            <span className="readToggle" onClick={() => setExpanded(!expanded)}>
              {expanded ? "Read Less" : "Read More"}
            </span>
          </div>

 
          <div>
            <Button
              className="muiBtn contus" 
              onClick={() => setShowForm(true)}
              variant="contained"
            >
              Contact us
            </Button>

          
            {showForm && (
              <div className="popupOverlay" onClick={() => setShowForm(false)}>
                <div className="popupForm" onClick={(e) => e.stopPropagation()}>
                  
               
                

             
                  <ContactForm />
                  <span className="closeBtn" onClick={() => setShowForm(false)}>
                    ✕
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>

      
        <div className="abCrd">
          <div className="abCLft">
            <p>
              Arvind Plots Vadodara stands apart for the strong sense of
              community it cultivates...Arvind Plots Vadodara stands apart for the strong sense of community it cultivates. With a thoughtfully planned layout and lush green surroundings, the development encourages a lifestyle that balances comfort, privacy, and connection. Residents not only enjoy their individual plots but also benefit from shared facilities, landscaped parks, and recreational spaces that elevate everyday living.
            </p>
          </div>
          <div className="abCRyt">
            <img src={ab1} alt="about-image" />
          </div>
        </div>

        <div className="abCrd abRev">
          <div className="abCLft">
            <p>
           Arvind SmartSpaces Project Vadodara is celebrated for its commitment to quality and excellence. Each plot is thoughtfully developed, offering owners the freedom to shape their spaces according to their vision. Whether you imagine a modern residence or a commercial establishment, the plots serve as a blank canvas for your aspirations. Sustainability remains a core focus, ensuring that future developments follow modern eco-friendly standards.
            </p>
          </div>
          <div className="abCRyt">
            <img src={ab2} alt="about-image" />
          </div>
        </div>

        <div className="abCrd">
          <div className="abCLft">
            <p>
           Investing in Arvind Smart Spaces Vadodara is not only about building a dream home — it's a strategic financial decision. With rising residential demand in Vadodara, especially along Ajwa Road, the value of land continues to appreciate year after year. As the city grows and infrastructural developments advance, investors are likely to witness substantial long-term returns.
            </p>
          </div>
          <div className="abCRyt">
            <img src={ab3} alt="about-image" />
          </div>
        </div>

        <div className="abCrd abRev">
          <div className="abCLft">
            <p>
             Arvind SmartSpaces combines technology, sustainability and modern community planning to create future-ready living environments. From superior infrastructure to thoughtfully integrated amenities, the project ensures a lifestyle rooted in convenience and comfort. Every aspect has been shaped to elevate life, nurture family growth and provide an address to take pride in.
            </p>
          </div>
          <div className="abCRyt">
            <img src={ab4} alt="about-image" />
          </div>
        </div>
      </div>
    </div>
  );
}
